import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { getEarlyRequestResult } from '../utils/earlyRequest';
const fetchLimitUsage = () => http.get('/feature/store/v1/usage', {
  query: {
    upgradeApiName: 'crm-suite-starter-bundle'
  }
});
export const GET_LIMIT_USAGE = registerQuery({
  fieldName: 'limitUsages',
  args: ['earlyRequestName'],
  fetcher({
    earlyRequestName
  }) {
    return getEarlyRequestResult(earlyRequestName, fetchLimitUsage);
  }
});